

<div class="app-body" (window:resize)="onResize()" ontouchmove >
   
    <router-outlet></router-outlet>
   
</div>